import {
    DeliveryClient
} from '@kentico/kontent-delivery';

const kenticoClient = (config) => new DeliveryClient(config);

export default kenticoClient


